import { formatPercentages } from 'helpers/formatData';
import { formatCurrency } from 'helpers/formatData';

export const likedRows = (report) => {
  return {
    propertyName: report?.propertyName ?? 'NA',
    propertyType: report?.propertyType ?? 'NA',
    likes: report?.likes ?? 0,
  };
};

export const appreciatedRows = (report) => {
  return {
    propertyName: report?.propertyName ?? 'NA',
    propertyType: report?.propertyType ?? 'NA',
    LTP: formatCurrency(report?.LTP ?? 0),
    gain: formatPercentages(report?.gain ?? 0),
  };
};

export const tradedRows = (report) => {
  return {
    propertyName: report?.propertyName ?? 'NA',
    propertyType: report?.propertyType ?? 'NA',
    totalInvestors: report?.totalInvestors ?? 0,
    volume: report?.volume ?? 0,
  };
};
